<nz-space nzDirection="vertical" style="width: 100%">
  <nz-space-item *ngIf="toBinLocations.length > 0">
    <nz-select style="width: 100%" [(ngModel)]="toBinLocationValue" [nzSize]="'large'"
      [nzPlaceHolder]="'Receiving Bin:' | locale">
      <nz-option *ngFor="let binLocation of toBinLocations" [nzValue]="binLocation.AbsEntry"
        [nzLabel]="binLocation.BinCode">
      </nz-option>
    </nz-select>
  </nz-space-item>
  <nz-space-item>
    <nz-input-group [nzPrefix]="scanIcon" nzSize="large">
      <input nz-input nzSize="large" [(ngModel)]="serialSearchValue" [placeholder]="'Search for serial no.' | locale"
        [nzAutocomplete]="serialNumbersAuto" (blur)="searchForSerial()" (keydown)="searchForSerial($event)" />
    </nz-input-group>
    <nz-autocomplete #serialNumbersAuto [nzDefaultActiveFirstOption]="false">
      <ng-container *ngFor="let serialNumber of autoCompleteSerialNumbers">
        <nz-auto-option [nzValue]="serialNumber.DistNumber" [nzDisabled]="(toBinActivated && serialNumber.BinAbs === toBinLocationValue)">
          {{serialNumber.DistNumber}}
          <nz-alert *ngIf="(toBinActivated && serialNumber.BinAbs === toBinLocationValue)" [nzType]="'warning'" [nzMessage]="'This serial number already in the target bin' | locale">
          </nz-alert>
        </nz-auto-option>
      </ng-container>
    </nz-autocomplete>
    <ng-template #scanIcon>
      <i nz-icon nzType="barcode" nzTheme="outline"></i>
    </ng-template>
  </nz-space-item>
  <nz-space-item>
    <nz-table #outBoundSnTable [nzData]="visibleSerialNumbers">
      <thead>
        <tr>
          <th>
            {{'#' | locale}}
          </th>
          <th>
            {{'Serial Number' | locale}}
          </th>
          <th *ngIf="toBinActivated">
            {{'To Bin Location' | locale}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let serialNumber of outBoundSnTable.data">
          <td>
            <button nz-button nzType="primary" nzShape="circle" nzDanger (click)="deleteSerial(serialNumber);">
              <i nz-icon nzType="delete"></i>
            </button>
          </td>
          <td>
            {{serialNumber.DistNumber}}
          </td>
          <td *ngIf="toBinActivated">
            <nz-select style="width: 100%" [(ngModel)]="serialNumber.ToBinLocation">
              <nz-option *ngFor="let binLocation of toBinLocations" [nzValue]="binLocation.AbsEntry"
                [nzLabel]="binLocation.BinCode">
              </nz-option>
            </nz-select>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-space-item>
</nz-space>
